export const SET = 'CONFIG/SET';